import Tr from 'translations/Translations';

const createItem = (trKey, value) => ({label: Tr(trKey), value})

const itemsHidedExecutive = [
	createItem('p1s1_ct_1', 'Standard'),
	createItem('p1s1_ct_2', 'Framework')
]

const itemsWithExecutive = [
	...itemsHidedExecutive,
	createItem('p1s1_ct_3', 'Executive')
]


export default (hideExecutiveDemandVariant) => {
    if (hideExecutiveDemandVariant) {
    	return itemsHidedExecutive;
    } else {
    	return itemsWithExecutive;
	}
}
